import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
request.get('/api/deviceinspecttask/page', Object.assign({}, options, { params }));

export const getDetail = (params, options) =>
request.get('/api/deviceinspecttask/detail', Object.assign({}, options, { params }))

export const getReport = (params, options) =>
  request.get('/api/deviceinspecttask/getReport', Object.assign({}, options, { params }))

export const remove = (params, options) =>
request.post('/api/deviceinspecttask/remove', qs.stringify(params),options);

export const add = (params, options) =>
request.post('/api/deviceinspecttask/submit', params,options);

export const update = (params, options) =>
request.post('/api/deviceinspecttask/update', params,options);

export const getTaskList = (params, options) =>
  request.get('/api/deviceinspecttasklist/getTaskList', Object.assign({}, options, { params }));

export const getTaskListPage = (params, options) =>
  request.get('/api/deviceinspecttasklist/getTaskListPage', Object.assign({}, options, { params }));
